import {
    CORE_GET_USERS_REQUEST,
    CORE_GET_USERS_SUCCESS,
    CORE_GET_USERS_FAILURE,

    CORE_GET_USER_INFO_REQUEST,
    CORE_GET_USER_INFO_SUCCESS,
    CORE_GET_USER_INFO_FAILURE,


    REQUEST_STATE
} from '../types'
const requestState = REQUEST_STATE

export default {
    user: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_USER_INFO_REQUEST:
                return state
            case CORE_GET_USER_INFO_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_GET_USER_INFO_FAILURE:
                return {}
            default:
                return state
        }
    },
    users: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_USERS_REQUEST:
                return state
            case CORE_GET_USERS_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_GET_USERS_FAILURE:
                return []
            default:
                return state
        }
    },
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/user.js